import DateFnsUtils from "@date-io/date-fns";
import { InlineDatePicker, MuiPickersUtilsProvider } from "material-ui-pickers";

import classes from "./DateRangePicker.module.css";

const MASK_TIME = [
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  "/",
  /\d/,
  /\d/,
  "/",
  /\d/,
  /\d/,
  " ",
  /\d/,
  /\d/,
  ":",
  /\d/,
  /\d/,
];

const DateRangePicker = ({
  value,
  onChange,
  isTime,
  startDateLabel = "Thời gian bắt đầu",
  endDateLabel = "Thời gian kết thúc",
}) => {
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <div className={classes.container}>
        <InlineDatePicker
          label={startDateLabel}
          variant="outlined"
          value={value[0]}
          onChange={(startDate) => onChange([startDate, value[1]])}
          format={isTime ? "yyyy/MM/dd HH:mm" : "dd-MM-yyyy"}
          keyboard
          maxDate={new Date()}
          required
          invalidDateMessage="Định dạng Ngày không đúng"
          maxDateMessage="Ngày lớn hơn ngày tối đa"
          minDateMessage="Ngày nhỏ hơn ngày tối thiểu"
          InputLabelProps={{
            shrink: true,
          }}
          className={classes.datePicker}
          autoComplete="off"
          mask={isTime ? MASK_TIME : undefined}
        />
        <InlineDatePicker
          label={endDateLabel}
          variant="outlined"
          maxDate={new Date()}
          value={value[1]}
          minDate={value[0]}
          format={isTime ? "yyyy/MM/dd HH:mm" : "dd-MM-yyyy"}
          onChange={(endDate) => onChange([value[0], endDate])}
          name="lte"
          keyboard
          required
          invalidDateMessage="Định dạng Ngày không đúng"
          maxDateMessage="Ngày lớn hơn ngày tối đa"
          minDateMessage="Ngày nhỏ hơn ngày tối thiểu"
          InputLabelProps={{
            shrink: true,
          }}
          className={classes.datePicker}
          autoComplete="off"
          mask={isTime ? MASK_TIME : undefined}
        />
      </div>
    </MuiPickersUtilsProvider>
  );
};

export default DateRangePicker;
